import { FC } from 'react'
import { IOrderItem } from '../../model/IOrder'
import priceFormatter from '../../utils/priceFormatter'
import Table, { ITableTh } from '../common/table/Table'
import TextMore from '../common/TextMore'
import EditableText from '../form/EditableText'
import { TPatchOrderItem } from '../../hooks/useOrder'
import { useAccess } from '../../hooks/useAccess'
import TrackingProductWidget from './TrackingProductWidget'

const ProductsList: FC<{
  products: IOrderItem[]
  patchOrderItem?: TPatchOrderItem
  loading?: boolean
}> = ({ products, patchOrderItem }) => {
  const { getSettingAccess } = useAccess()

  const thead: ITableTh[] = [
    { title: 'Name' },
    { title: 'Vendor' },
    { title: 'Interchange' },
    { title: 'Part Type' },
    { title: 'Product#' },
    { title: 'Supplier ID' },
    { title: 'Stock#' },
    ...(getSettingAccess('order-product-price') ? [{ title: 'Price' }] : []),
    { title: 'Make' },
    { title: 'Model' },
    { title: 'Year' },
    { title: 'Vendor Price' },
    { title: 'Shipping' },
    { title: 'Invoice #' },
    { title: 'vOrder #' },
    { title: 'Description' },
  ]

  return !products?.length ? null : (
    <Table
      thead={thead}
      tbody={products.map((product) => ({
        extraRow: (
          <div className='flex gap-4 pt-[.5em] px-[2.2em] pb-[1em] items-center'>
            <div className='flex gap-2'>
              <b>Tracking Shipper:</b>
              {product?.siCarrier}
            </div>
            <div className='flex gap-2'>
              <b>Tracking #:</b>
              {product?.siTrackingNum}
            </div>
            <TrackingProductWidget orderItem={product} />
          </div>
        ),
        data: [
          <div className='whitespace-nowrap'>{product.name || '-'}</div>,
          <div className='whitespace-nowrap'>
            {product.vendor?.name || '-'} ({product.vendor?.externalKey || '-'})
          </div>,
          <div className='whitespace-nowrap'>{product.interchangeNumber || '-'}</div>,
          product.partTypeCode || '-',
          product.pid || '-',
          product.supplierId || '-',
          product.stockNumber || '-',
          ...(getSettingAccess('order-product-price') ? [product.price] : []),
          product.viMake || '-',
          <div className='whitespace-nowrap'>{product.viModel || '-'}</div>,
          product.viYear || '-',
          priceFormatter(product.vPrice),
          priceFormatter(product.actualShippingPrice),
          getSettingAccess('order-product-invoice-edit') ? (
            <EditableText
              value={product.supplierInvoice || 'add invoice'}
              size='medium'
              onSave={async (value) =>
                value !== 'add invoice' &&
                patchOrderItem &&
                (await patchOrderItem(product.orderId, product.id, 'supplierInvoice', value || ''))
              }
            />
          ) : (
            product.supplierInvoice
          ),
          product.salesOrderNumber,
          product.fullDescription ? (
            <TextMore title={`Description for ${product.name}`} text={product.fullDescription} />
          ) : (
            '-'
          ),
        ],
      }))}
    />
  )
}

export default ProductsList
